import { createContext, useMemo } from 'react';

import { useLocalStorage } from '../../../../hooks/useLocalStorage';
import { useAppSelector } from '../../../../hooks/hooksRedux';

import { RootState } from '../../../../store';

import { ServiceBaseConfig } from '../Services/Interface';

const BillingPaymentsContext = createContext<any>({});

const BillingPaymentsProvider = ({ children }: any) => {
  const [token] = useLocalStorage('access-token', null);
  const { legalPersonalitySlug } = useAppSelector((state: RootState) => state.language);
  const config: ServiceBaseConfig | null = useMemo(() => {
    if (!token) {
      return null;
    }

    return {
      headers: {
        'Content-Language': legalPersonalitySlug,
        Authorization: `Bearer ${token}`
      }
    };
  }, [legalPersonalitySlug, token]);
  // const handleGetBillingInformation = useCallback(async () => {
  //   setIsLoading(true);
  //   try {
  //     if (token) {
  //       const { data } = await BillingPaymentService.getBillingInformation(config);
  //       // setBillingInformation(data)
  //       setIsLoading(false);
  //       return data;
  //     }
  //     setIsLoading(false);
  //     throw new Error('Error Token does not exist in Get Billing Information');
  //   } catch (error) {
  //     setIsLoading(false);
  //     console.error('Error Get Billing Information', error);
  //   }
  // }, []);

  // useEffect(() => {
  //   void handleGetBillingInformation();
  // }, []);
  const valuesContext = useMemo(() => ({ config }), [config]);

  return <BillingPaymentsContext.Provider value={valuesContext}>{children}</BillingPaymentsContext.Provider>;
};

export { BillingPaymentsContext, BillingPaymentsProvider };
